import { Trans, t } from "@lingui/macro";
import Image from "next/image";
import styled from "styled-components";
import { Button } from "~/guidelines/Button";
import { Stack } from "~/guidelines/Flex";
import { body1, heading2, heading5 } from "~/guidelines/Typography";
import Checkbox from "../_assets/specifications/checkbox.svg";
import Send from "../_assets/specifications/send.svg";

const Container = styled(Stack)`
  align-items: center;
  max-width: 1200px;
  background-color: ${({ theme }) => theme.color.background.lightFirst};
  margin: 80px auto;
  padding: 0px 200px;
  padding-bottom: 80px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: 32px 16px;
    padding: 0px 16px 32px 16px;
  }
`;

const PreTitle = styled.h5`
  ${heading5}
  margin-bottom: 0px;
`;

const Title = styled.h2`
  ${heading2}
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  text-align: center;
`;

const List = styled(Stack)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(8)};
`;

const ItemContainer = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px;
  gap: 24px;
  border: 1px solid ${({ theme }) => theme.color.line.lightSecond};

  &:not(:first-child) {
    border-top: none;
  }
`;

const ItemText = styled.p`
  ${body1}
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Specifications = () => {
  const LIST_ITEMS = [
    t`French cities with over 100,000 inhabitants with a TGV station, city center, prime location`,
    t`Renovation, rehabilitation, character building`,
    t`Walls and business assets`,
    t`25-50 keys, between 450 and 1500 m²`,
    t`With breakfast room`,
  ];

  return (
    <Container>
      <PreTitle>
        <Trans>Our</Trans>
      </PreTitle>

      <Title>
        <Trans>specifications</Trans>
      </Title>

      <List>
        {LIST_ITEMS.map((item) => (
          <ItemContainer key={item}>
            <Image src={Checkbox} alt="checkbox" />

            <ItemText>{item}</ItemText>
          </ItemContainer>
        ))}
      </List>

      <Button
        size="large"
        href="https://encore-mieux.typeform.com/to/p5ssSaDE?typeform-source=encore-mieux.com"
      >
        <FlexCenter>
          <Image src={Send} alt="send" />
          <Trans>Submit my project</Trans>
        </FlexCenter>
      </Button>
    </Container>
  );
};

export default Specifications;
